import { Controller } from "@hotwired/stimulus"
import * as Turbo from "../src/shared/vendor/turbo"

export default class extends Controller {
  static values = {
    action: String,
    method: { type: String, default: "POST" },
    accept: { type: String, default: "application/json" }
  }

  async submit () {
    const response = await fetch(this.actionValue, {
      method: this.methodValue.toUpperCase(),
      headers: {
        'Content-Type': 'application/json',
        Accept: this.acceptValue,
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({})
    })

    if (response.ok) {
      const contentType = response.headers.get("Content-Type")

      if (contentType.includes("turbo-stream")) {
        const html = await response.text()
        Turbo.renderStreamMessage(html) // 🚀 this applies the turbo_stream updates
      } else if (contentType.includes("json")) {
        const data = await response.json()

        if (data.message) {
          sessionStorage.setItem('flashMessage', JSON.stringify({
            message: data.message?.text,
            type: data.message?.kind
          }))
        }

        if (data.redirect_url) {
          window.location.href = data.redirect_url
        }
      }
    }
  }
}
